import { render } from "./UIBlocker.vue?vue&type=template&id=4fc5dfe0"
import script from "./UIBlocker.vue?vue&type=script&lang=js"
export * from "./UIBlocker.vue?vue&type=script&lang=js"

import "./UIBlocker.vue?vue&type=style&index=0&id=4fc5dfe0&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__